import { traningTrackingRecord } from "../../utils/types"

export const statusBgColor = (status: string): string => {
    switch (status) {
      case 'Open':
        return 'lightGreen'
      case 'Lapsing':
        return 'paleYellow'
      case 'Expired':
        return 'palePink'
      default:
        return 'gray3'
    }
  }

  export const getStatus = (targetDateString: string): string => {
    // Parse the target date string into a Date object
    const targetDate = new Date(targetDateString);
  
    // Get the current date
    const currentDate = new Date();
  
    // Calculate the difference in milliseconds between the target date and the current date
    const differenceInMs = targetDate.getTime() - currentDate.getTime();
  
    // Convert milliseconds to days
    const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
  
    // Check the conditions and return the status
    if (differenceInDays < 0) {
      return 'Expired';
    } else if (differenceInDays <= 10) {
      return 'Lapsing';
    } else {
      return 'Open';
    }
  };

  export const checkEmptyFields = (obj: traningTrackingRecord): string => {
    for (const key in obj) {
      if ( obj[key as keyof traningTrackingRecord]?.length== 0) {
        console.log(obj[key as keyof traningTrackingRecord]?.length)
        return 'No';
      }
    }
    return 'Yes';
  };
  export const calculatePageCount = (dataLength: number): number => {
    if (dataLength < 8) {
      return 1
    } else {
      return Math.ceil(dataLength / 7)
    }
  }